import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowDown } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-wc-blue text-white overflow-hidden pt-12 pb-12 lg:pt-16 lg:pb-16 min-h-screen flex items-center" data-id="element-115">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-116">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiLz48L3N2Zz4=')] bg-repeat opacity-20" data-id="element-117"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 w-full" data-id="element-118">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-120">
            <div className="inline-block bg-wc-yellow text-wc-dark font-bold px-3 py-1 rounded-full text-xs mb-3 uppercase tracking-wider" data-id="element-121">
              🏆 Megapack Álbum Mundial 2026
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl leading-tight mb-4 text-white drop-shadow-lg" data-id="element-122">
              El Álbum del Mundial 2026 que Podés Completar HOY...{' '}
              <span className="text-wc-yellow" data-id="element-123">
                Sin Gastar una Fortuna en Sobres
              </span>
            </h1>
          </motion.div>

          <motion.div className="relative w-full max-w-[240px] sm:max-w-[280px] mb-4" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} data-id="element-124">
            <div className="absolute inset-0 bg-wc-yellow rounded-full blur-3xl opacity-20 animate-pulse" data-id="element-125"></div>
            <img src="https://cdn.magicpatterns.com/uploads/aVKH1hXYW3qhyndYou829G/Diseno_sin_titulo_(16).png" alt="Mockup Álbum Mundial 2026" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-126" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="w-full" data-id="element-127">
            <p className="text-base sm:text-lg lg:text-xl mb-6 text-blue-100 font-medium max-w-2xl mx-auto" data-id="element-128">
              Descargá, Imprimí y Viví la Pasión del Mundial desde Casa — Con
              Todas las Figuritas, Todos los Equipos y Todo el Álbum Listo en
              Minutos
            </p>

            <a href="#pricing" className="inline-flex items-center justify-center gap-3 bg-wc-red hover:bg-red-700 text-white font-bold py-4 px-8 rounded-xl text-lg lg:text-xl transition-transform transform hover:scale-105 shadow-2xl mb-5" data-id="element-129">
              QUIERO ACCESO AL ÁLBUM
              <ArrowDown size={22} className="animate-bounce" data-id="element-130" />
            </a>

            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs sm:text-sm text-blue-200" data-id="element-131">
              <div className="flex items-center gap-1.5" data-id="element-132">
                <CheckCircle size={16} className="text-wc-yellow" data-id="element-133" />
                <span data-id="element-134">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-135">
                <CheckCircle size={16} className="text-wc-yellow" data-id="element-136" />
                <span data-id="element-137">Alta Resolución</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-138">
                <CheckCircle size={16} className="text-wc-yellow" data-id="element-139" />
                <span data-id="element-140">Pago Seguro</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}